import { useEffect } from 'react';
import { useLogout } from '../../API/services/authService';
import { ROLES } from '../../roles';
import { useAuth } from './AuthContext';

const IDLE_TIMEOUT = 20 * 60 * 1000; // 20 minutes

const SessionManager = () => {
  const user = useAuth(); // ✅ moved inside
  const logoutUser = useLogout();
  useEffect(() => {
    console.log('useeffect', user?.user?.role);

    if (user?.user?.role !== ROLES.CASE_MANAGER) return;

    let idleTimer: ReturnType<typeof setTimeout>;

    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        console.log('idle');
        logoutUser();
      }, IDLE_TIMEOUT);
    };

    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
    ];

    events.forEach((event) => globalThis.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(idleTimer);
      events.forEach((event) =>
        globalThis.removeEventListener(event, resetTimer)
      );
    };
  }, [user]);

  useEffect(() => {
    const handleLogoutSync = (event: StorageEvent) => {
      if (event.key === 'logout-event') {
        globalThis.location.href = '/';
      }
    };

    globalThis.addEventListener('storage', handleLogoutSync);

    return () => {
      globalThis.removeEventListener('storage', handleLogoutSync);
    };
  }, []);

  return null;
};

export default SessionManager;
